import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import SelectorCiudad from "../custom/SelectorCiudad";
import Unauthorized from "../general/Unauthorized";

function NuevoUsuario() {

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonDatosBasicos, setAcordeonDatosBasicos] = useState(true);
    const [acordeonProfesionalSalud, setAcordeonProfesionalSalud] = useState(false);
    const [acordeonUsuarioSistema, setAcordeonUsuarioSistema] = useState(false);
    //const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    //const [permissions, setPermissions] = useState([]);

    //const [roleName, setRoleName] = useState('');
    //const [roleDescription, setRoleDescription] = useState();

    const [cargos, setCargos] = useState([]);
    const [tiposContrato, setTiposContrato] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);

    const [roles, setRoles] = useState([]);
    const [name, setName] = useState();
    const [lastname, setLastname] = useState();
    const [email, setEmail] = useState();
    const [documento, setDocumento] = useState();
    const [tipoDocumento, setTipoDocumento] = useState();
    const [celular, setCelular] = useState();
    const [cargo, setCargo] = useState();
    const [tipoContrato, setTipoContrato] = useState();
    const [registroMedico, setRegistroMedico] = useState();
    const [especialidad, setEspecialidad] = useState();
    const [codigoHabilitacion, setCodigoHabilitacion] = useState();
    const [direccion, setDireccion] = useState();
    const [ciudadResidencia, setCiudadResidencia] = useState(null);
    const [telefono, setTelefono] = useState();
    const [fechaNacimiento, setFechaNacimiento] = useState();
    const [estadoCivil, setEstadoCivil] = useState();
    const [fechaIngreso, setFechaIngreso] = useState();
    const [porcentajeContratado, setPorcentajeContratado] = useState();




    const [crearCuenta, setCrearCuenta] = useState(false);
    const [asignarRolesVisible, setAsignarRolesVisible] = useState('hide');
    const [camposUsuarioVisible, setCamposUsuarioVisible] = useState(false);
    const [usuariosDisponibles, setUsuariosDisponibles] = useState(0);
    const [usuariosCreados, setUsuariosCreados] = useState(0);

    const [usrRoles, setUsrRoles] = useState([]);
    const [crearAgenda, setCrearAgenda] = useState(false);
    const [login, setLogin] = useState();
    const [diligenciarHistorias, setDiligenciarHistorias] = useState(false);
    const [facturador, setFacturador] = useState(1); // 🆕 Campo facturador - Default 1 (No es facturador)

    let history = useHistory();

    let userdata = [];
    //let clientData = [];
    //let userRoles = [];

    const addRole = (roleId) => {

        let userRoles = usrRoles;

        let roleIndex = userRoles.indexOf(roleId);
        if (roleIndex > -1) {
            userRoles.splice(roleIndex, 1);
        }
        else {
            userRoles.push(roleId);
        }

        var roleElement = document.getElementById('role-' + roleId);
        roleElement.classList.toggle('on');

        setUsrRoles(userRoles);
    }

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
            console.log('DEBUG NuevoUsuario - Usando sistema nuevo de permisos');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
            console.log('DEBUG NuevoUsuario - Usando sistema antiguo de permisos (fallback)');
        }

        console.log('DEBUG NuevoUsuario - tienePermiso gestionPersonal:', tienePermiso); // ✅ DEBUG

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }


        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente');
            });


        axios.get('/roles', config)
            .then(response => {
                if (response.status === 200) {
                    setRoles(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando roles');
            });

        axios.get('/cargos', config)
            .then(response => {
                if (response.status === 200) {
                    setCargos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando cargos');
            });


        axios.get('/tipos-contrato', config)
            .then(response => {
                if (response.status === 200) {
                    setTiposContrato(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando tipos contrato');
            });

        axios.get('/especialidades', config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando especialidades');
            })

        // 📊 CARGAR INFORMACIÓN DE USUARIOS DISPONIBLES
        axios.get('/parametros-cliente', config)
            .then(response => {
                if (response.status === 200 && response.data) {
                    setUsuariosDisponibles(response.data.numero_usuarios_disponibles || 0);
                    setUsuariosCreados(response.data.usuarios_creados || 0);
                }
            })
            .catch(error => {
                console.log('Error cargando parámetros cliente');
                // Valores por defecto si no se puede cargar
                setUsuariosDisponibles(0);
                setUsuariosCreados(0);
            })
    }, []);


    const handleCrearCuenta = () => {
        if (crearCuenta) {
            // Desactivar: ocultar campos
            setCrearCuenta(false);
            setAsignarRolesVisible('hide');
            setCamposUsuarioVisible(false);
            // 🎨 Remover clase visual 'on'
            document.getElementById('crear_cuenta').classList.remove('on');
        }
        else {
            // Activar: validar usuarios disponibles
            const usuariosRestantes = usuariosDisponibles - usuariosCreados;

            if (usuariosRestantes <= 0) {
                alert('No te quedan usuarios disponibles. Contacte con el administrador del sistema.');
                return; // No permitir activar el switch
            }

            // Si hay usuarios disponibles, activar
            setCrearCuenta(true);
            setAsignarRolesVisible('');
            setCamposUsuarioVisible(true);
            // 🎨 Agregar clase visual 'on'
            document.getElementById('crear_cuenta').classList.add('on');
        }
    }

    const handleCrearAgenda = () => {
        setCrearAgenda(!crearAgenda);
        // 🎨 Toggle visual del switch
        document.getElementById('agenda-crear').classList.toggle('on');
    }

    const handleDiligenciarHistorias = () => {
        setDiligenciarHistorias(!diligenciarHistorias);
        // 🎨 Toggle visual del switch
        document.getElementById('diligenciar-historias').classList.toggle('on');
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        // 🔧 VALIDACIÓN FRONTEND - Limpiar errores previos
        setErrorlist({});

        // 🔧 VALIDACIÓN FRONTEND - Verificar campos requeridos
        const errores = {};

        if (!name || name.trim() === '') {
            errores.name = 'El nombre es requerido';
        }

        if (!lastname || lastname.trim() === '') {
            errores.lastname = 'El apellido es requerido';
        }

        if (!email || email.trim() === '') {
            errores.email = 'El email es requerido';
        }

        if (!documento || documento.trim() === '') {
            errores.numero_documento = 'El número de documento es requerido';
        }

        if (!tipoDocumento || tipoDocumento.trim() === '') {
            errores.tipo_documento = 'El tipo de documento es requerido';
        }

        // 🔧 VALIDACIÓN: Porcentaje contratado debe ser válido si se proporciona
        if (porcentajeContratado && porcentajeContratado !== '') {
            const porcentaje = parseInt(porcentajeContratado);
            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                errores.porcentaje_contratado = 'El porcentaje debe ser un número entre 0 y 100';
            }
        }

        // Si hay errores, no enviar el formulario
        if (Object.keys(errores).length > 0) {
            setErrorlist(errores);
            setLoading(false);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            name: name,
            lastname: lastname,
            email: email,
            numero_documento: documento,
            tipo_documento: tipoDocumento,
            celular: celular,
            // 🔧 VALIDACIÓN: Convertir strings vacíos a null para campos integer
            cargo: cargo && cargo !== '' ? parseInt(cargo) : null,
            tipo_contrato: tipoContrato && tipoContrato !== '' ? parseInt(tipoContrato) : null,
            especialidad: especialidad && especialidad !== '' ? parseInt(especialidad) : null,
            // 🔧 VALIDACIÓN: Campos de texto pueden ser vacíos
            registro_medico: registroMedico || null,
            codigo_habilitacion: codigoHabilitacion || null,
            crear_cuenta: crearCuenta,
            direccion: direccion || null,
            // 🔧 VALIDACIÓN: Ciudad debe ser integer (ID de ciudad) o null
            ciudad: ciudadResidencia && ciudadResidencia !== '' ? parseInt(ciudadResidencia) : null,
            telefono: telefono || null,
            fecha_nacimiento: fechaNacimiento || null,
            estado_civil: estadoCivil || null,
            fecha_ingreso: fechaIngreso || null,
            // 🔧 VALIDACIÓN: Porcentaje debe ser número o null
            porcentaje_contratado: porcentajeContratado && porcentajeContratado !== '' ? parseInt(porcentajeContratado) : null,
            crear_agenda: crearAgenda,
            login: login || null,
            diligenciar_historias: diligenciarHistorias,
            facturador: facturador // 🆕 Enviar campo facturador
        };

        if (crearCuenta) {
            conf.roles = JSON.stringify(usrRoles);
        }

        axios.post('/user', conf)
            .then(
                response => {
                    setLoading(false);
                    //localStorage.setItem('userdata',JSON.stringify(response.data));
                    //localStorage.setItem('nuevo_usuario',email);
                    localStorage.setItem('toastmsg', 'El usuario "' + name + ' ' + lastname + '" ha sido creado');
                    history.push('/personal');
                }
            )
            .catch(
                err => {
                    console.log('Error del servidor:', err.response?.data);

                    // 🔧 MANEJO DE ERRORES MEJORADO
                    if (err.response?.data?.errors) {
                        setErrorlist(err.response.data.errors);
                    } else if (err.response?.data?.message) {
                        // Error general del servidor
                        setErrorlist({ general: err.response.data.message });
                    } else {
                        // Error de conexión u otro
                        setErrorlist({ general: 'Error de conexión. Por favor, intente nuevamente.' });
                    }

                    setLoading(false);
                }
            )
    }










    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (

            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .nu-section-card { border-radius: 12px !important; overflow: hidden; }
                    .nu-section-header {
                        background: #f8f9fa;
                        border-bottom: 1px solid #eef0f2;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 14px 18px;
                        user-select: none;
                    }
                    .nu-section-header:hover { background: #f3f5f7; }
                    .nu-section-title { font-size: 1rem; font-weight: 700; color: #323a45; margin: 0; display: flex; align-items: center; gap: 10px; }
                    .nu-fieldset {
                        border: 1px solid #eef0f2;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem 0.65rem;
                        margin-bottom: 1.15rem;
                        background: #fcfcfd;
                    }
                    .nu-fieldset legend {
                        float: none;
                        width: auto;
                        padding: 0 6px;
                        margin-bottom: 0.85rem;
                        font-size: 0.72rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.45px;
                        color: #7d7d7d;
                    }
                    .nu-subcard {
                        border: 1px solid #e8ecef;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem;
                        background: #fff;
                        margin-top: 1rem;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    }
                    .nu-subcard legend {
                        float: none;
                        width: auto;
                        padding: 0 10px;
                        font-size: 0.92rem;
                        font-weight: 700;
                        color: #117a8b;
                        margin-bottom: 0.75rem;
                    }
                    .nu-alert-danger { border-radius: 10px; border: none; box-shadow: 0 2px 8px rgba(220,53,69,0.12); }
                    .nu-users-badge {
                        display: inline-block;
                        margin-top: 6px;
                        padding: 4px 12px;
                        border-radius: 999px;
                        font-size: 0.72rem;
                        font-weight: 700;
                        background: rgba(23,162,184,0.1);
                        color: #117f90;
                        border: 1px solid rgba(23,162,184,0.2);
                    }
                    .role-selector-card {
                        display: flex;
                        align-items: center;
                        padding: 12px 15px;
                        border: 1px solid #e8ecef;
                        border-radius: 10px;
                        margin-bottom: 15px;
                        background: #ffffff;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.04);
                    }
                    .role-selector-card:hover {
                        border-color: #17a2b8;
                        background: #f6fcfd;
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(23,162,184,0.1);
                    }
                    .role-selector-card .sm-switch-container {
                        width: 50px !important;
                        height: 26px !important;
                        margin-right: 12px;
                        flex-shrink: 0;
                    }
                    .role-selector-card .sm-switch-container .sm-switch {
                        width: 20px !important;
                        height: 20px !important;
                        top: 3px !important;
                        left: 3px !important;
                    }
                    .role-selector-card .sm-switch-container.on .sm-switch {
                        left: 27px !important;
                    }
                    .role-selector-card label {
                        margin: 0 !important;
                        cursor: pointer !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        color: #323a45 !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .nu-fieldset-inner { border: 1px solid #eef0f2; border-radius: 12px; padding: 1rem; background: #fafbfc; margin-top: 0.5rem; }
                    .nu-crear-cuenta-row {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 12px 14px;
                        min-height: 38px;
                    }
                    .nu-crear-cuenta-row .nu-crear-cuenta-label {
                        margin: 0;
                        font-weight: 600;
                        color: #495057;
                        font-size: 13px;
                        line-height: 1.35;
                        flex: 1 1 140px;
                        min-width: 0;
                    }
                    .nu-crear-cuenta-row .sm-switch-container {
                        flex-shrink: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/personal">Personal y Profesionales</Link></li>
                                        <li className="breadcrumb-item active" key="bc5">Nuevo Personal</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Nuevo Personal</h1>
                                    <p className="text-muted mb-0 mt-1" style={{ fontSize: '0.85rem' }}>Registre datos del colaborador y, si aplica, cuenta de acceso al sistema.</p>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/personal" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al listado
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <form id="role-form" onSubmit={handleSubmit}>

                                        {errorlist.general && (
                                            <div className="alert alert-danger nu-alert-danger" role="alert">
                                                <i className="fas fa-exclamation-triangle mr-2"></i>{errorlist.general}
                                            </div>
                                        )}

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonDatosBasicos(!acordeonDatosBasicos)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-id-card text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Datos básicos
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonDatosBasicos ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="infobasica" className={acordeonDatosBasicos ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información personal</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Nombres</label>
                                                                    <input type="text" name="name" className="form-control" id="name" autoFocus onChange={(e) => setName(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="lastname">Apellidos</label>
                                                                    <input type="text" name="lastname" className="form-control" id="lastname" onChange={(e) => setLastname(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.lastname}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_documento">Tipo Documento</label>
                                                                    <select name="tipo_documento" id="tipo_documento" className="form-control" onChange={(e) => setTipoDocumento(e.target.value)}>
                                                                        <option value=""></option>
                                                                        <option value="cc">CC - CEDULA DE CIUDADANIA</option>
                                                                        <option value="ce">CE - CEDULA DE EXTRANJERIA</option>
                                                                        <option value="CD">CD - CARNET DIPLOMATICO</option>
                                                                        <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                                                        <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                                                        <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                                                        <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                                                        <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                                                        <option value="PA">PA - PASAPORTE</option>
                                                                        <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                                                        <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                                                        <option value="RC">RC - REGISTRO CIVIL</option>
                                                                        <option value="ti">TI - TARJETA DE IDENTIDAD</option>
                                                                        <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                                                        <option value="SI">SI - SIN IDENTIFICACION</option>
                                                                        <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.tipo_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="documento">Documento</label>
                                                                    <input type="text" name="documento" className="form-control" id="documento" onChange={(e) => setDocumento(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.numero_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información de contacto</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="direccion">Dirección</label>
                                                                    <input type="text" name="direccion" className="form-control" id="direccion" onChange={(e) => setDireccion(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.direccion}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="ciudadResidencia">Ciudad de Residencia</label>
                                                                    <SelectorCiudad
                                                                        value={ciudadResidencia}
                                                                        onChange={setCiudadResidencia}
                                                                    />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.ciudad}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="telefono">Teléfono Fijo</label>
                                                                    <input type="text" name="telefono" className="form-control" id="telefono" onChange={(e) => setTelefono(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.telefono}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="celular">Teléfono Celular</label>
                                                                    <input type="text" name="celular" className="form-control" id="celular" onChange={(e) => setCelular(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.celular}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="email">Email</label>
                                                                    <input type="text" name="email" className="form-control" id="email" onChange={(e) => setEmail(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_nacimiento">Fecha de Nacimiento</label>
                                                                    <input type="date" name="fecha_nacimiento" className="form-control" id="fecha_nacimiento" onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.fecha_nacimiento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="estado_civil">Estado Civil</label>
                                                                    <select name="tipo-sangre" className="form-control" id="estadoCivil" onChange={(e) => setEstadoCivil(e.target.value)}>
                                                                        <option value=""></option>
                                                                        <option value="soltero">SOLTERO</option>
                                                                        <option value="casado">CASADO</option>
                                                                        <option value="separado">SEPARADO</option>
                                                                        <option value="viudo">VIUDO</option>
                                                                        <option value="union_libre">UNIÓN LIBRE</option>
                                                                        <option value="otro">OTRO</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.estado_civil}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </fieldset>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonProfesionalSalud(!acordeonProfesionalSalud)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-user-md text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Profesional de la salud
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonProfesionalSalud ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="datosadicionales" className={acordeonProfesionalSalud ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información laboral</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_ingreso">Fecha de Ingreso</label>
                                                                    <input type="date" name="fecha_ingreso" className="form-control" id="fecha_ingreso" onChange={(e) => setFechaIngreso(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.fecha_ingreso}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="cargo">Cargo</label>
                                                                    <select name="cargo" id="cargo" className="form-control" onChange={(e) => setCargo(e.target.value)}>
                                                                        <option value="00">-</option>
                                                                        {
                                                                            cargos.map((cargoItem) =>
                                                                                <option value={cargoItem.id} key={'k' + cargoItem.id}>{cargoItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_contrato">Tipo de Contrato</label>
                                                                    <select name="tipo_contrato" id="tipo_contrato" className="form-control" onChange={(e) => setTipoContrato(e.target.value)}>
                                                                        <option value="00">-</option>
                                                                        {
                                                                            tiposContrato.map((tc) =>
                                                                                <option value={tc.id} key={'j' + tc.id}>{tc.nombre}</option>
                                                                            )
                                                                        }

                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="registro_medico">Registro Médico</label>
                                                                    <input type="text" name="registro_medico" className="form-control" id="registro_medico" onChange={(e) => setRegistroMedico(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="especialidad">Especialidad</label>
                                                                    <select name="especialidad" id="especialidad" className="form-control" onChange={(e) => setEspecialidad(e.target.value)}>
                                                                        <option value="00">-</option>
                                                                        {
                                                                            especialidades.map((especialidadItem) =>
                                                                                <option value={especialidadItem.id} key={'p' + especialidadItem.id}>{especialidadItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="codigo_habilitacion">Código de Habilitación</label>
                                                                    <input type="text" name="codigo_habilitacion" className="form-control" id="codigo_habilitacion" onChange={(e) => setCodigoHabilitacion(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="porcentaje_contratado">Porcentaje Contratado</label>
                                                                    <input type="number" min="0" max="100" name="porcentaje_contratado" className="form-control" id="porcentaje_contratado" onChange={(e) => setPorcentajeContratado(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.porcentaje_contratado}
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </div>

                                                        <div className="col-md-12 pt-2">
                                                            <label className="d-block font-weight-bold text-secondary small text-uppercase mb-2">¿Crear agenda para este profesional?</label>
                                                            <div className="sm-switch-container" id="agenda-crear" onClick={handleCrearAgenda}>
                                                                <span className="sm-switch"></span>
                                                            </div>
                                                        </div>

                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonUsuarioSistema(!acordeonUsuarioSistema)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-key text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Usuario del sistema
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonUsuarioSistema ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="rolesusuario" className={acordeonUsuarioSistema ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    {/* Alineado con col-md-3 de «Fecha de ingreso» del acordeón anterior */}
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group mb-2">
                                                                <div className="nu-crear-cuenta-row">
                                                                    <label className="nu-crear-cuenta-label" htmlFor="crear_cuenta">
                                                                        ¿Crear cuenta de usuario en la plataforma?
                                                                    </label>
                                                                    <div className="sm-switch-container" id="crear_cuenta" onClick={handleCrearCuenta}>
                                                                        <span className="sm-switch"></span>
                                                                    </div>
                                                                </div>
                                                                <span className="nu-users-badge mt-2 d-inline-block">
                                                                    Disponibles: {Math.max(0, usuariosDisponibles - usuariosCreados)} / {usuariosDisponibles}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* 🔒 CAMPOS CONDICIONALES - SOLO VISIBLES SI SE ACTIVA EL SWITCH */}
                                                    {camposUsuarioVisible && (
                                                        <>
                                                            {/* 🔐 INFORMACIÓN DE INICIO DE SESIÓN */}
                                                            <fieldset className="nu-subcard">
                                                                <legend>Datos de inicio de sesión</legend>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor="login">Usuario de ingreso (login)</label>
                                                                            <input type="text" name="login" className="form-control" id="login" onChange={(e) => setLogin(e.target.value)} />
                                                                            <div className="invalid-feedback visible">
                                                                                {errorlist?.login}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {/* 🏥 PERMISOS CLÍNICOS */}
                                                            <fieldset className="nu-subcard">
                                                                <legend>Permisos clínicos</legend>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <label htmlFor="diligenciar_historias" className="font-weight-bold text-secondary">¿Puede diligenciar historias clínicas?</label>
                                                                        <small className="text-muted d-block mb-2">Permite asignar este profesional en atenciones a pacientes.</small>
                                                                        <div className="sm-switch-container" id="diligenciar-historias" onClick={handleDiligenciarHistorias}>
                                                                            <span className="sm-switch"></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {/* 💰 PERMISOS DE FACTURACIÓN */}
                                                            <fieldset className="nu-subcard">
                                                                <legend>Permisos de facturación</legend>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <label htmlFor="facturador" className="font-weight-bold text-secondary">¿Es facturador?</label>
                                                                        <select 
                                                                            className="form-control mt-1" 
                                                                            value={facturador} 
                                                                            onChange={(e) => setFacturador(parseInt(e.target.value))}
                                                                            style={{ maxWidth: '520px', borderRadius: '10px' }}
                                                                        >
                                                                            <option value={0}>Sí - Puede crear RIPS FEV y Convenios</option>
                                                                            <option value={1}>No - Solo RIPS Sin FEV</option>
                                                                        </select>
                                                                        <small className="form-text text-muted">
                                                                            Define qué opciones de RIPS puede usar el usuario al atender pacientes
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {/* 👥 ASIGNACIÓN DE ROLES */}
                                                            <div className={'row ' + asignarRolesVisible} style={{ marginTop: '12px' }}>
                                                                <div className="col-md-12">
                                                                    <fieldset className="nu-fieldset-inner">
                                                                        <legend className="mb-3" style={{ fontSize: '0.92rem', fontWeight: 700, color: '#117a8b', border: 'none', padding: 0 }}>Asignar perfil de usuario</legend>
                                                                        <div className="row">
                                                                            {roles.map((role) =>
                                                                                <div className="col-md-4" key={'role-' + role.id}>
                                                                                    <div className="role-selector-card" onClick={() => addRole(role.id)}>
                                                                                        <div className="sm-switch-container" id={'role-' + role.id}>
                                                                                            <span className="sm-switch"></span>
                                                                                        </div>
                                                                                        <label title={role.name}>{role.name}</label>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row align-items-center mb-4" style={{ marginTop: '8px' }}>
                                            <div className="col-md-auto pr-md-2">
                                                <button type="submit" className="btn btn-info font-weight-bold px-4" disabled={loading} style={{ borderRadius: '10px', minWidth: '200px' }}>
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                            Guardando…
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-save mr-2"></i>
                                                            Guardar personal
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                            <div className="col-md-auto pt-2 pt-md-0">
                                                <Link to="/personal" className="btn btn-outline-secondary" style={{ borderRadius: '10px' }}>
                                                    Cancelar
                                                </Link>
                                            </div>
                                        </div>




                                    </form>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default NuevoUsuario;